import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import RefreshIcon from '@material-ui/icons/Refresh';
import Input from 'components/Material/Input';
import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import { postApiAndFunctionName, postChangePwd, snackBarRsp } from 'main_api';
import { setLoadingRedux } from 'reducers/shareData/action';
import { getUserInfoRedux } from 'reducers/shareData/selector';
import Header from 'components/Header';
import { Imaster } from './type';

const initialMaster: Imaster = {
  oldPwd: '',
  newPwd: '',
  newPwdConfirm: '',
};

const ChangePwdMtn = (): JSX.Element => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [master, setMaster] = useState<Imaster>(initialMaster);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const [formError, setFormError] = useState('');

  const updateData = (name: keyof Imaster, value: string) => {
    setMaster((current) => ({ ...current, [name]: value }));
    setFormError('');
  };

  const handleReset = () => {
    setMaster(initialMaster);
    setFormError('');
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (master.newPwd !== master.newPwdConfirm) {
      setFormError('新密碼與新密碼確認不一致。');
      return;
    }

    dispatch(setLoadingRedux(true));
    try {
      const result = await postApiAndFunctionName(
        'changePwdMtn',
        'changePwd',
        master
      );
      if (snackBarRsp(enqueueSnackbar, result) && result.data.status === 0) {
        setFormError('修改密碼成功。');

        const handleRedirect = () => {
          window.location.href = '/';
        };
        // 1. 設定 2 秒後自動跳轉
        const timer = setTimeout(handleRedirect, 2000);

        // 2. 彈出可點擊的非阻塞提示
        enqueueSnackbar('修改密碼成功！', {
          variant: 'success',
          autoHideDuration: 2000,
          onClick: () => {
            clearTimeout(timer);
            handleRedirect();
          },
        });
        return;
      }
    } catch (error) {
      setFormError('修改密碼失敗，請稍後再試。');
    } finally {
      dispatch(setLoadingRedux(false));
    }
  };

  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 修改密碼
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*舊密碼：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={4}>
              <Input
                required
                type="password"
                value={master.oldPwd}
                name="oldPwd"
                onChange={(event) => updateData('oldPwd', event.target.value)}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*新密碼：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={4}>
              <Input
                required
                type="password"
                value={master.newPwd}
                name="newPwd"
                onChange={(event) => updateData('newPwd', event.target.value)}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*新密碼確認：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={4}>
              <Input
                required
                type="password"
                value={master.newPwdConfirm}
                name="newPwdConfirm"
                onChange={(event) =>
                  updateData('newPwdConfirm', event.target.value)
                }
              />
            </VcGrid>
          </Grid>
        </div>
        {formError && (
          <div style={{ color: 'red', margin: '0 1em' }}>{formError}</div>
        )}
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm="auto">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
            >
              確定
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              type="button"
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={handleReset}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default ChangePwdMtn;
